<!-- PAGE CONTENT ROUTER OUTLET -->

<!-- *ngIf="coordinatorAccess || routeWhitelisted" -->
<div
  *ngIf="coordinatorAccess || routeWhitelisted"
  class="mat-elevation-z1 flex--r-c-sb breadcrumbs-container"
  style="background-color: #fff; z-index: 100; position: relative"
>
  <wh-breadcrumbs class="w-h-page-breadcrumbs"></wh-breadcrumbs>
  <div class="right-side-wrapper" *ngIf="displayFilter && canRemoveFilter()">
    <app-team-list
      [canRemoveFilter]="canRemoveFilter()"
      [teamList]="teamDOMList()"
      [selectedTeam]="selectedTeamDOM"
      (teamSelected)="selectionChange($event)"
      (teamRemoved)="removeFilter()"
    ></app-team-list>
  </div>
</div>

<!-- *ngIf="coordinatorAccess || routeWhitelisted" -->
<div class="w-h-page-content" *ngIf="coordinatorAccess || routeWhitelisted">
  <router-outlet></router-outlet>
</div>

<mat-card
  class="no-access-page"
  *ngIf="!coordinatorAccess && !routeWhitelisted"
>
  <h2
    color="primary"
    class="main-message"
    [innerHTML]="'flow.app.accessrightinformation' | translate"
  ></h2>
  <h3
    class="extra-message"
    [innerHTML]="'flow.app.additionalaccessrightinformation' | translate"
  ></h3>
</mat-card>
